module.exports = __webpack_public_path__ + "media/images/card_backgrounds/master_degree-cf4258fc8b86292f678e4635dfdf6f3a.png";